export const replaceBaseOrigin = (baseOrigin: string, destination: string) => {
  return baseOrigin.replace(
    /^(https?:\/\/)(local|iam|console|account|beyond-console|beyond-account|preview-console)/,
    `$1${destination}`,
  );
};
